import { FC } from 'react';
import EsgExposureContainer from './subComponents/EsgExposureContainer.component';
import { Grid } from '@mui/material';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import {
  EsgPages,
  useEsgCodeDescriptions,
  useEsgFundData,
  type EsgCodeDescriptions,
  type EsgPortfolioSummaryPageModel,
} from '../../../../api/rs-hg/esg';

export const esgRuleSortValue = (value: string): number => {
  // Return a numeric value depending on what the string starts with.
  if (value.startsWith('M-EE')) return 0;
  else if (value.startsWith('EE')) return 1;
  else if (value.startsWith('M-ES')) return 2;
  else if (value.startsWith('ES')) return 3;
  else if (value.startsWith('M-EG')) return 4;
  else if (value.startsWith('EG')) return 5;
  else if (value.startsWith('A')) return 6;
  else if (value.startsWith('P')) return 7;
  else if (value.startsWith('SFDR')) return 8;
  else return 9;
};

type EsgExposureQueryData = {
  pageModel: EsgPortfolioSummaryPageModel;
  rulesData: EsgCodeDescriptions;
};

const ESGExposure: FC<FundInfoComponentProps> = ({
  fundId,
  fundName,
  positionDate,
}) => {
  const portfolioSummaryQuery = useEsgFundData(
    fundId,
    positionDate,
    EsgPages.ESG_EXPOSURE,
  );
  const codeDescriptionsQuery = useEsgCodeDescriptions();

  return (
    <QueryBoundary<EsgExposureQueryData>
      isLoading={
        portfolioSummaryQuery.isLoading || codeDescriptionsQuery.isLoading
      }
      isFetching={
        portfolioSummaryQuery.isFetching || codeDescriptionsQuery.isFetching
      }
      isError={portfolioSummaryQuery.isError || codeDescriptionsQuery.isError}
      error={portfolioSummaryQuery.error ?? codeDescriptionsQuery.error}
      data={
        portfolioSummaryQuery.data?.data &&
        Object.keys(portfolioSummaryQuery.data.data).length > 0 &&
        !('no data' in portfolioSummaryQuery.data.data) &&
        codeDescriptionsQuery.data &&
        Object.keys(codeDescriptionsQuery.data).length > 0
          ? {
              pageModel: portfolioSummaryQuery.data,
              rulesData: codeDescriptionsQuery.data,
            }
          : null
      }
      loadingMessages={['Loading ESG Data...', '...']}
      errorMessage="No ESG Data Found"
      noDataMessage="No ESG Data Found"
    >
      {({ pageModel, rulesData }) => (
        <Grid container spacing={2} style={{ padding: 8 }}>
          <EsgExposureContainer
            fundId={fundId}
            fundName={fundName}
            positionDate={
              pageModel.returned_position_date ??
              pageModel.selected_position_date ??
              positionDate
            }
            esgData={pageModel.data}
            rulesData={rulesData}
          />
        </Grid>
      )}
    </QueryBoundary>
  );
};

export default ESGExposure;
